/* eslint-disable react/prop-types */
import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { useStyles } from "./termSheet.style";

const TermSheetTable = (props) => {
  const classes = useStyles();
  const {
    loanData,
    customWidth,
    isFeeDetails,
    handleDeleteFee,
    feeDetailsData,
    handleFeeChange,
    handleFeeBlur
  } = props;

  return (
    <Grid className={classes.termSheetTableContainer}>
      {loanData &&
        loanData?.map((loan) => {
          return (
            <Grid
              item
              container
              className={classes.container}
              style={{ borderBottom: "1px solid #e1e8ee" }}
            >
              <Grid
                item
                container
                xs={customWidth?.label ? customWidth?.label : 7}
                className={classes.tableLabel}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderRight: "1px solid #D5D5D5"
                }}
              >
                <Typography>{loan?.label}</Typography>
                {isFeeDetails ? (
                  <IconButton
                    title='Delete'
                    sx={{ padding: "0px", marginBottom: "4px" }}
                  >
                    <DeleteOutlineIcon
                      fontSize='small'
                      sx={{ color: "#362866" }}
                      onClick={() => {
                        return handleDeleteFee(loan.mainLabel, feeDetailsData);
                      }}
                    />
                  </IconButton>
                ) : null}
              </Grid>
              <Grid
                item
                container
                xs={customWidth?.value ? customWidth?.value : 5}
              >
                {isFeeDetails ? (
                  <TextField
                    data-testid={`fee-detail-${loan.id}`}
                    fullWidth
                    type='string'
                    size='small'
                    value={loan?.value}
                    sx={{ border: "none" }}
                    onChange={(e) => {
                      return handleFeeChange(e, loan.mainLabel, feeDetailsData);
                    }}
                    onBlur={(e) => {
                      return handleFeeBlur(
                        e.target.value,
                        loan.mainLabel,
                        feeDetailsData
                      );
                    }}
                  />
                ) : (
                  <Typography
                    className={classes.tableValue}
                    dangerouslySetInnerHTML={{
                      __html: loan?.value
                    }}
                  />
                )}
              </Grid>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default React.memo(TermSheetTable);
